import { m as motion } from 'framer-motion';
import { ConnectedInput } from '@eti/form';
import { string } from '@eti/utils';
import { css, mediaQueries } from '@eti/styles';
import { vars } from '@etg/wings';
import { useEffect, useState } from 'react';
import { useProperty, useTranslation } from '@eti/providers';
import { persistTaxId, removeSessionTaxId } from '../utils/utils';
import { TAX_ID_INPUT } from '../utils/constants';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const transition = {
  type: 'tween',
  duration: 0.2
};
const containerVariants = {
  hidden: {
    maxHeight: 0,
    transition
  },
  visible: {
    maxHeight: '175px',
    transition
  }
};
const itemVariants = {
  hidden: {
    transform: 'translateY(-100%)',
    transition
  },
  visible: {
    transform: 'translateY(0%)',
    transition
  }
};
const {
  colors: {
    divider: lightGray
  },
  card: {
    borderRadius
  }
} = vars;
const inputStyles = css`
  background-color: #fff;
  border-end-end-radius: ${borderRadius};
  border-end-start-radius: ${borderRadius};
  border-top: 1px solid ${lightGray};
  padding: 16px;

  span {
    height: auto;
    margin-top: 0;
  }
`;
const taxStyles = css`
  @media ${mediaQueries.medium.up} {
    width: 50%;
  }
`;
function TaxIdInput(_ref) {
  let {
    isSelected,
    recoverSessionTaxId
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    p
  } = useProperty();
  const [renderInput, setRenderInput] = useState(false);
  const onStart = () => setRenderInput(true);
  const onComplete = variant => {
    setRenderInput(variant === 'visible');
  };
  const taxIdLabel = p('Payment.TaxIdFeature.Label');
  const labelWithoutSlash = taxIdLabel === null || taxIdLabel === void 0 ? void 0 : taxIdLabel.replace('/', '');
  const taxIdInputTextHint = t(`Payment.TaxIdField.Input.Hint.${labelWithoutSlash}`);
  const taxIdInputTextLabel = string.insertArgument(t('Payment.TaxIdField.Input.Placeholder'), taxIdLabel) || `Enter your ${taxIdLabel} number`;
  useEffect(() => {
    removeSessionTaxId();
  }, []);
  useEffect(() => {
    if (!isSelected) {
      removeSessionTaxId();
    } else {
      recoverSessionTaxId();
    }
  }, [isSelected, recoverSessionTaxId]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isSelected && /*#__PURE__*/_jsx(motion.div, {
      animate: isSelected ? 'visible' : 'hidden',
      className: css`
            overflow: hidden;
          `,
      initial: "hidden",
      onAnimationComplete: onComplete,
      onAnimationStart: onStart,
      variants: containerVariants,
      children: /*#__PURE__*/_jsx(motion.div, {
        className: inputStyles,
        variants: itemVariants,
        children: renderInput && /*#__PURE__*/_jsx(ConnectedInput, {
          "aria-hidden": !isSelected,
          autoCapitalize: "off",
          autoCorrect: "off",
          className: taxStyles,
          "data-testid": "cpf-textInput",
          description: taxIdInputTextHint,
          label: taxIdInputTextLabel,
          maxLength: 32,
          name: TAX_ID_INPUT,
          onChange: e => persistTaxId(e.target.value),
          spellCheck: "false",
          validationRuleName: TAX_ID_INPUT
        })
      })
    })
  });
}
export default TaxIdInput;
//# sourceMappingURL=TaxIdInput.js.map